import { OpenFeature } from '@openfeature/web-sdk';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useEffect } from 'react';

import { createLaunchDarklyClientProvider } from './createLaunchDarklyClientProvider';

export const OpenFeatureBridge = (): null => {
  const ldClient = useLDClient();

  useEffect(() => {
    if (!ldClient) return;
    OpenFeature.setProviderAndWait(createLaunchDarklyClientProvider(ldClient)).catch(
      (err: unknown) => {
        console.error('[OpenFeatureBridge] Failed to set OpenFeature provider:', err);
      },
    );
  }, [ldClient]);

  return null;
};
